import { render, staticRenderFns } from "./GuidedClaimsEditor.vue?vue&type=template&id=f33c7e82&scoped=true&"
import script from "./GuidedClaimsEditor.vue?vue&type=script&lang=js&"
export * from "./GuidedClaimsEditor.vue?vue&type=script&lang=js&"
import style0 from "./GuidedClaimsEditor.vue?vue&type=style&index=0&id=f33c7e82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33c7e82",
  null
  
)

export default component.exports